import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight, FiZap, FiBarChart2 } from "react-icons/fi";
import { FaHandshake } from "react-icons/fa";
import "./LetsBuild.css";

const LetsBuild = () => {
  const sectionRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const section = sectionRef.current;

    if (!section) return;

    const animatedElements = section.querySelectorAll(
      ".section-label, .lets-build h2, .lets-build-description, .lets-build-buttons, .lets-build-highlights, .lets-build-visual",
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animatedElements.forEach((element, index) => {
              setTimeout(() => {
                element.classList.add("lets-build-visible");
              }, index * 120);
            });

            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0.15,
      },
    );

    observer.observe(section);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section className="lets-build" id="lets-build" ref={sectionRef}>
      {/* =========================
          LEFT CONTENT
      ========================== */}

      <div className="lets-build-content">
        {/* Section Label */}
        <div className="section-label">
          <span></span>

          <p>LET’S BUILD</p>

          <span></span>
        </div>

        {/* Heading */}
        <h2>
          Let’s Build Something
          <br />
          <span>Great Together</span>
        </h2>

        {/* Description */}
        <p className="lets-build-description">
          Have an idea, project, or business challenge?
          <br />
          Let’s turn it into a smart and scalable digital solution.
        </p>

        {/* =========================
            CTA BUTTONS
        ========================== */}

        <div className="lets-build-buttons">
          {/* Primary Button */}
          <button
            type="button"
            className="primary-btn"
            onClick={() => navigate("/contactus")}
          >
            <span>Get in Touch</span>
            <FiArrowRight />
          </button>

          {/* Secondary Button 
          <button
            type="button"
            className="secondary-btn"
            onClick={() => navigate("/contactus")}
          >
            <FiUsers />
            <span>Talk to Our Teams</span>
          </button>*/}
        </div>

        {/* =========================
            HIGHLIGHTS
        ========================== */}

        <div className="lets-build-highlights">
          {/* Innovate */}
          <div className="highlight-item">
            <div className="highlight-icon">
              <FiZap />
            </div>

            <div className="highlight-content">
              <h4>Innovate</h4>
              <p>Turn Ideas Into Solutions</p>
            </div>
          </div>

          {/* Divider */}
          <div className="highlight-divider"></div>

          {/* Build */}
          <div className="highlight-item">
            <div className="highlight-icon">
              <FiBarChart2 />
            </div>

            <div className="highlight-content">
              <h4>Build</h4>
              <p>Create Real Value</p>
            </div>
          </div>

          {/* Divider */}
          <div className="highlight-divider"></div>

          {/* Grow */}
          <div className="highlight-item">
            <div className="highlight-icon">
              <FaHandshake />
            </div>

            <div className="highlight-content">
              <h4>Grow</h4>
              <p>Together for a Better Tomorrow</p>
            </div>
          </div>
        </div>
      </div>

      {/* =========================
          RIGHT VISUAL
      ========================== */}

      <div className="lets-build-visual">
        {/* =========================
            TECHNOLOGY IMAGE
        ========================== */}

        <div className="globe-container">
          <img
            src="/images/build-tech-images.png"
            alt="Digital Innovation Technology"
            className="digital-globe"
          />
        </div>
      </div>
    </section>
  );
};

export default LetsBuild;
